export type ChatQuotaTier = "LOW" | "HIGH";

export type ChatQuotaStatusSnapshot = {
  isLoaded: boolean;
  isExceeded: boolean;
  quotaLimit: number | null;
  remainingTokens: number | null;
  isUnlimited: boolean;
};

const WARNING_THRESHOLD_RATIO = 0.2;

function hasFiniteQuota(status: ChatQuotaStatusSnapshot) {
  return (
    status.isLoaded &&
    !status.isUnlimited &&
    typeof status.quotaLimit === "number" &&
    status.quotaLimit > 0 &&
    typeof status.remainingTokens === "number"
  );
}

export function isNearLimit(status: ChatQuotaStatusSnapshot) {
  if (!hasFiniteQuota(status) || status.isExceeded) {
    return false;
  }

  const remainingTokens = status.remainingTokens;
  const quotaLimit = status.quotaLimit;

  if (remainingTokens === null || quotaLimit === null) {
    return false;
  }

  return remainingTokens / quotaLimit <= WARNING_THRESHOLD_RATIO;
}

export function resolveRemainingPercentage(status: ChatQuotaStatusSnapshot) {
  if (!hasFiniteQuota(status)) {
    return null;
  }

  const remainingTokens = status.remainingTokens;
  const quotaLimit = status.quotaLimit;

  if (remainingTokens === null || quotaLimit === null) {
    return null;
  }

  return Math.max(
    0,
    Math.min(100, Math.round((remainingTokens / quotaLimit) * 100)),
  );
}
